import React from "react";

import { DesignToken, Heading, SpacingToken } from "@livechat/design-system-react-components";

import { SettingsNavigationGroup } from "constants/settings/interfaces";
import { withVar } from "themes/helpers";

import { NavigationItem } from "./NavigationItem";
import { isExternalNavigationItem } from "./helpers";
import { ISettingsSideNavigationItemWithBadge } from "./interfaces";

const GroupHeader: React.FC<{ name: SettingsNavigationGroup }> = ({ name }) => (
  <Heading
    size="2xs"
    uppercase
    bold
    customColor={withVar(DesignToken.ContentBasicPrimary)}
    css={{ padding: `${withVar(SpacingToken.Spacing2)} 0` }}
  >
    {name}
  </Heading>
);

interface IProps {
  group: SettingsNavigationGroup;
  items: ISettingsSideNavigationItemWithBadge[];
  activeItem?: string;
}
export const NavigationGroup: React.FC<IProps> = ({ group, items, activeItem }) => (
  <div>
    <GroupHeader name={group} />
    {items.map(item => (
      <NavigationItem
        key={item.name}
        item={item}
        active={!isExternalNavigationItem(item) && activeItem?.includes(item.path)}
      />
    ))}
  </div>
);
